import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CaisseAchatTactile from "./CaisseAchatTactile";
import SuiviDemandesAchats from "./SuiviDemandesAchats";
import ControleValidationAchats from "./ControleValidationAchats";
import ComparatifTroisFournisseurs from "./ComparatifTroisFournisseurs";
import FacturesAchatEmplacement from "./FacturesAchatEmplacement";
import CadenceAchatsStats from "./CadenceAchatsStats";
import GestionFamillesAchats from "./GestionFamillesAchats";
import "./DailyPurchases.css";

const DailyPurchaseHub = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.AuthReducer?.user);

  const isAdmin =
    currentUser?.role === "admin" || currentUser?.role === "useradmin";
  const isController =
    currentUser?.role === "controleur" ||
    (currentUser?.fonction && currentUser.fonction.toLowerCase().includes("control"));
  const isAdminOrController = isAdmin || isController;

  const initialTab = searchParams.get("tab") || "caisse";
  const [activeTab, setActiveTab] = useState(
    !isAdminOrController && !["caisse", "suivi"].includes(initialTab) ? "caisse" : initialTab
  );

  useEffect(() => {
    const tabFromUrl = searchParams.get("tab") || "caisse";
    if (!isAdminOrController && !["caisse", "suivi"].includes(tabFromUrl)) {
      setActiveTab("caisse");
      setSearchParams({ tab: "caisse" });
    } else if (tabFromUrl && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams, isAdminOrController]);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setSearchParams({ tab: tabKey });
  };

  return (
    <div className="dp-wrapper">
      {/* ── HEADER GÉNÉRAL DU MODULE ── */}
      <div className="dp-header">
        <div className="dp-header-title">
          <h2>
            <span>🛒</span> Achats Quotidiens & Approvisionnements
          </h2>
          <p>
            Caisse de demande tactile par emplacement, suivi en direct des demandes, validation contrôleur, benchmark 3 fournisseurs & factures.
          </p>
        </div>

        {/* Navigation par Onglets */}
        <div className="dp-nav-tabs">
          <button
            className={`dp-tab-btn ${activeTab === "caisse" ? "active" : ""}`}
            onClick={() => handleTabChange("caisse")}
          >
            🛒 Caisse Demande
          </button>

          <button
            className={`dp-tab-btn ${activeTab === "suivi" ? "active" : ""}`}
            onClick={() => handleTabChange("suivi")}
          >
            📦 Suivi de Mes Demandes
          </button>

          {isAdminOrController && (
            <>
              <button
                className={`dp-tab-btn ${activeTab === "controle" ? "active" : ""}`}
                onClick={() => handleTabChange("controle")}
              >
                📋 Validation & Contrôle
              </button>

              <button
                className={`dp-tab-btn ${activeTab === "fournisseurs" ? "active" : ""}`}
                onClick={() => handleTabChange("fournisseurs")}
              >
                ⚖️ Comparatif 3 Fournisseurs
              </button>

              <button
                className={`dp-tab-btn ${activeTab === "factures" ? "active" : ""}`}
                onClick={() => handleTabChange("factures")}
              >
                📑 Factures par Emplacement
              </button>

              <button
                className={`dp-tab-btn ${activeTab === "cadence" ? "active" : ""}`}
                onClick={() => handleTabChange("cadence")}
              >
                📈 Cadence & Historique
              </button>

              <button
                className={`dp-tab-btn ${activeTab === "familles" ? "active" : ""}`}
                onClick={() => handleTabChange("familles")}
              >
                ⚙️ Familles & Articles
              </button>
            </>
          )}
        </div>
      </div>

      {/* ── CONTENU DE L'ONGLET ACTIF ── */}
      <div className="dp-content">
        {activeTab === "caisse" && (
          <CaisseAchatTactile
            onNavigateToSuivi={() => handleTabChange("suivi")}
          />
        )}

        {activeTab === "suivi" && (
          <SuiviDemandesAchats
            onNewDemandClick={() => handleTabChange("caisse")}
          />
        )}

        {activeTab === "controle" && (
          <ControleValidationAchats
            onNavigateToSuivi={() => handleTabChange("suivi")}
          />
        )}

        {activeTab === "fournisseurs" && <ComparatifTroisFournisseurs />}

        {activeTab === "factures" && <FacturesAchatEmplacement />}

        {activeTab === "cadence" && <CadenceAchatsStats />}

        {activeTab === "familles" && <GestionFamillesAchats />}
      </div>
    </div>
  );
};

export default DailyPurchaseHub;
